// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { HistoryProvider } from "./Components/HistoryContext";
import { VideoCacheProvider } from "./Components/VideoCacheContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <HistoryProvider>
        <VideoCacheProvider>
          <App />
        </VideoCacheProvider>
      </HistoryProvider>
    </BrowserRouter>
  </React.StrictMode>
);